import * as actionType from '../actions/actionTypes';
import updateObject from '../Utility';

const initState = {
    queryParams: {},
    dashboardSection: null,
    crmPath: {},
    moduleList: [],
    pendingModuleOrder: null,
    selectedCrmModule: null,
    moduleSelectionMode: undefined, //show-records,select
    loading: false,
    errorMsg: undefined,
    successMsg: undefined,
    navigationPath: []
};

// const setRouteParams = (state, action) => {//todo112

//     return updateObject(state, { crmPath: action.payload.params });
// }

const setRouteParams = (state, action) => {
    const newPath = action.payload.params || {};      // the incoming crmPath
    const nextModule = newPath?.name;                    // new / undefined

    const moduleGone = !nextModule;                // clear ONLY if modal closed

    return updateObject(state, {
        crmPath: newPath,
        navigationPath: moduleGone ? [] : state.navigationPath
    });
};

const updateQueryParams = (state, action) => {//todo112

    return updateObject(state, { queryParams: action.payload.queryParams });
}

const updateDashboardSection = (state, action) => {//todo112

    return updateObject(state, { dashboardSection: action.payload.dashboardSection });
}

const setCrmModule = (state, action) => {
    const updatedModuleList = JSON.parse(JSON.stringify(state.moduleList))
    let { crmModule, selectionMode } = action.payload
    if (selectionMode === 'refresh') {
        selectionMode = state.moduleSelectionMode
    }
    if (crmModule?._id) {
        const toUpdateModuleIndex = updatedModuleList.findIndex((module) => module._id === crmModule._id)
        if (toUpdateModuleIndex > -1) {
            updatedModuleList.splice(toUpdateModuleIndex, 1, crmModule)
        }
        else {
            updatedModuleList.push(crmModule)
        }
    }

    return updateObject(state, { selectedCrmModule: crmModule, moduleSelectionMode: selectionMode, moduleList: updatedModuleList })//, moduleList: updatedModuleList
}

const startLoading = (state, action) => {
    return updateObject(state, { loading: true })
}

const finishLoading = (state, action) => {
    const errorMsg = action.payload.errorMsg
    const successMsg = action.payload.successMsg
    return updateObject(state, { loading: false, errorMsg, successMsg })
}

const initCrmModule = (state, action) => {
    const { moduleList } = action.payload
    return updateObject(state, { moduleList })
}

const changeCrmModuleOrder = (state, action) => {
    const updatedList = [...state.moduleList]; // Clone array
    const { active, over } = action.payload

    const oldIndex = updatedList.findIndex((item) => item._id === active.id);
    const newIndex = updatedList.findIndex((item) => item._id === over.id);
    if (oldIndex === -1 || newIndex === -1) return state; // Prevent invalid cases

    // Swap order values based on actual item order, not array index
    [updatedList[oldIndex].order, updatedList[newIndex].order] =
        [updatedList[newIndex].order, updatedList[oldIndex].order];

    // Ensure the list is correctly sorted by order before updating API
    const sortedList = updatedList.sort((a, b) => a.order - b.order);

    // Prepare module order for API
    const moduleOrder = sortedList.map((module, index) => ({
        moduleId: module._id,
        order: index + 1 // Assign a correct sequential order
    }));

    return updateObject(state, { moduleList: sortedList, pendingModuleOrder: moduleOrder })
}

const clearPendingModuleOrder = (state, action) => {
    return updateObject(state, { pendingModuleOrder: null })
}

const onCloseCrmAlertModalHandler = (state, action) => {
    return updateObject(state, { loading: false, errorMsg: undefined, successMsg: undefined })
}

const getUpdatedPath = (oldPath, seg) => {
    const path = [...oldPath];
    const idx = path.findIndex(p => p.module === seg.module);

    /* 1️⃣  LIST-PAGE SEGMENT (recordId === null)  */
    if (seg.recordId === null) {
        const last = oldPath[oldPath.length - 1];
        const insideRecord = last && last.recordId !== null;

        if (idx === -1) {                         // grid not present yet
            return insideRecord ? [...oldPath, seg] // drill-down from record
                : [seg];            // first load or top-level nav
        }

        // grid already exists in the breadcrumb → user clicked it
        return [seg];                             // reset to that grid only
    }

    /* 2️⃣  RECORD SEGMENT (recordId !== null)  */
    if (idx === -1) {
        // module wasn’t in the path at all
        return [...path, seg];
    }

    const sameRecord = path[idx].recordId === seg.recordId;

    if (path[idx].recordId === null) {
        // we were on the list, now entering a record
        const newPath = [...path];
        newPath.splice(idx + 1);      // drop anything after the list
        newPath.push(seg);            // add the record
        return newPath;
    }

    if (sameRecord) {
        // same record again (maybe label got better) → overwrite & keep children
        const newPath = [...path];
        newPath[idx] = { ...newPath[idx], ...seg };
        return newPath;
    }

    // different record of the same module → replace this module onward
    const newPath = path.slice(0, idx); // keep everything before this module
    newPath.push(seg);
    return newPath;
};

const addOrUpdateNavPath = (state, action) => {
    return updateObject(state, { navigationPath: getUpdatedPath(state.navigationPath, action.payload) });
}

const deleteModuleById = (state, action) => {
    const { moduleId } = action.payload
    const newModuleList = JSON.parse(JSON.stringify(state.moduleList))
    const toDeleteModuleIndex = newModuleList.findIndex((module) => {
        return module._id === moduleId
    })
    if (toDeleteModuleIndex > -1) {
        newModuleList.splice(toDeleteModuleIndex, 1)
    }
    return updateObject(state, { moduleList: newModuleList,selectedCrmModule:null });
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actionType.SET_ROUTE_PARAMS: return setRouteParams(state, action);
        case actionType.UPDATE_QUERY_PARAMS: return updateQueryParams(state, action);
        case actionType.UPDATE_DASHBOARD_SECTION: return updateDashboardSection(state, action);
        case actionType.SET_CRM_MODULE: return setCrmModule(state, action);
        case actionType.START_CRM_LOADING: return startLoading(state, action);
        case actionType.FINISH_CRM_LOADING: return finishLoading(state, action);
        case actionType.INIT_CRM_MODULE_LIST: return initCrmModule(state, action);
        case actionType.CHANGE_CRM_MODULE_ORDER: return changeCrmModuleOrder(state, action)
        case actionType.CLEAR_PENDING_MODULE_ORDER: return clearPendingModuleOrder(state, action)
        case actionType.CLEAR_CRM_ALERT: return onCloseCrmAlertModalHandler(state, action)
        case actionType.ADD_OR_UPDATE_NAV_PATH: return addOrUpdateNavPath(state, action)//DELETE_MODULE
        case actionType.DELETE_MODULE: return deleteModuleById(state, action)
        default:
            return state
    }
}

export default reducer;